import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useSidebarMenuStore } from "@senciamatch/frontend/stores/useSidebarMenuStore";
import { useWorkShiftEditStore } from "@senciamatch/frontend/stores/useWorkShiftEditStore";
import { Navigate, Outlet } from "react-router-dom";
import { ModifySidebar } from "./components/ModifySidebar";
import { Sidebar } from "./components/Sidebar";

export const TwoColumnLayout = () => {
  const { error } = trpc.getUsers.useQuery();
  const { modifySidebarIsOpen, sidebarIsOpen } = useSidebarMenuStore();
  const { sessions } = useWorkShiftEditStore();

  // Check if there are any sessions with changes
  const hasChanges = sessions.some((session) => session.changes && session.changes.length > 0);

  if (error?.data?.httpStatus === 401) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex w-screen h-screen bg-gray-100">
      {sidebarIsOpen && (
        <aside className="fixed top-0 left-0 w-72 h-screen bg-white border-r border-gray-200 shadow-lg z-[9999] transition-transform duration-300 ease-in-out">
          <div className="h-full">
            <Sidebar />
          </div>
        </aside>
      )}
      {!sidebarIsOpen && (
        <button
          type="button"
          className="w-10 h-10 fixed top-4 left-4 border border-gray-300 rounded-full shadow-sm bg-slate-50 z-[9999]"
          onClick={() => {
            useSidebarMenuStore.getState().setIsOpen(true);
          }}
        >
          <img src="/icons/double-arrow-right.svg" alt=">>" className="w-10 h-10 pt-1 pb-2 pl-[7px] pr-1 fill-black" />
        </button>
      )}
      <main
        className={`flex-grow px-20 min-h-screen overflow-auto transition-all duration-300 relative ${
          modifySidebarIsOpen ? "mr-80" : "mr-0"
        } ${sidebarIsOpen ? "ml-72" : "ml-0"}`}
      >
        {/* シフト修正パネル開閉ボタン - 変更がある場合のみ表示 */}
        {!modifySidebarIsOpen && hasChanges && (
          <button
            type="button"
            onClick={() => useSidebarMenuStore.getState().toggleModifySidebar()}
            className="w-10 h-10 fixed top-4 right-4 border border-gray-300 rounded-full shadow-sm bg-slate-50 z-[9998]"
            title="シフト修正パネルを開く"
          >
            {/* シフト/カレンダーアイコン */}
            <svg className="w-6 h-6 text-gray-600 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <title>シフト修正パネルを開く</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </button>
        )}
        <Outlet />
      </main>
      {modifySidebarIsOpen && (
        <aside className="fixed top-0 right-0 w-80 h-screen bg-white border-l border-gray-200 shadow-lg z-[9999] transition-transform duration-300 ease-in-out">
          <div className="h-full p-4">
            <ModifySidebar />
          </div>
        </aside>
      )}
    </div>
  );
};
